import { render, staticRenderFns } from "./BooleanAttribute.vue?vue&type=template&id=0a1231a9"
import script from "./BooleanAttribute.vue?vue&type=script&lang=js"
export * from "./BooleanAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports